import React from 'react'
import { useTranslation } from 'react-i18next'
import { TextField } from '~common/components/text-field'
import { getCountryOptions, getCountryName } from '~/utils/locale'
import { Icon } from '~common/components/icon/icon'
import { ExpandableSection } from '../section-wrapper'
import { FormGroup } from '../shared-styles'
import type { SettingsModalLogic } from '../../logic'

interface CompanyInfoSectionProps {
    logic: SettingsModalLogic
    state: { countryCode: string }
    expanded: boolean
    onToggle: () => void
    showTitleInSection?: boolean
}

export const CompanyInfoSection: React.FC<CompanyInfoSectionProps> = ({
    logic,
    state,
    expanded,
    onToggle,
    showTitleInSection = true,
}) => {
    const displayValue = state.countryCode
        ? getCountryName(state.countryCode)
        : ''

    const { t } = useTranslation('settings')
    return (
        <ExpandableSection
            title={t('sections.companyInfo.title')}
            description={t('sections.companyInfo.description')}
            expanded={expanded}
            onToggle={onToggle}
            iconName="globe"
            iconColor={({ theme }) => theme.colors.text.primary}
            showTitleInSection={showTitleInSection}
        >
            <FormGroup>
                <TextField
                    label={t('sections.companyInfo.country')}
                    initValue={displayValue}
                    onChange={(countryCode: string) =>
                        logic.updateCountryCode(countryCode)
                    }
                    editable={true}
                    dropdown={true}
                    options={getCountryOptions()}
                    placeholder={t('sections.companyInfo.selectCountry')}
                    width="100%"
                    size="large"
                />
            </FormGroup>
        </ExpandableSection>
    )
}
